// Step 3 (Choose delivery type) of CallOffWizard.tsx, split out to keep
// CallOffWizard.tsx under the 500-line cap. No behaviour change from the
// original inline JSX — moved verbatim.
import { Warehouse, MapPin } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';
import type { CallOffCustomerConfig } from '../../../lib/api';

interface CallOffWizardDestinationStepProps {
  callOffConfig: CallOffCustomerConfig;
  onChooseWarehouse: () => void;
  onChooseDirect: () => void;
}

export default function CallOffWizardDestinationStep({
  callOffConfig,
  onChooseWarehouse,
  onChooseDirect,
}: CallOffWizardDestinationStepProps) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">Choose the type of delivery to add:</p>
      <div className={`grid gap-4 ${callOffConfig.direct_delivery_enabled ? 'grid-cols-2' : 'grid-cols-1'}`}>
        <Card
          className="cursor-pointer hover:border-red-300 hover:bg-red-50/50 transition-colors"
          onClick={onChooseWarehouse}
        >
          <CardContent className="p-6 text-center space-y-3">
            <Warehouse className="h-12 w-12 mx-auto text-red-500" />
            <div>
              <p className="font-medium text-lg">Warehouse</p>
              <p className="text-sm text-muted-foreground">
                Select parts from stock planning grid
              </p>
            </div>
          </CardContent>
        </Card>
        {callOffConfig.direct_delivery_enabled && (
          <Card
            className="cursor-pointer hover:border-blue-300 hover:bg-blue-50/50 transition-colors"
            onClick={onChooseDirect}
          >
            <CardContent className="p-6 text-center space-y-3">
              <MapPin className="h-12 w-12 mx-auto text-blue-500" />
              <div>
                <p className="font-medium text-lg">Direct Delivery</p>
                <p className="text-sm text-muted-foreground">
                  Select from sales orders for direct delivery
                </p>
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
